import { Factory } from '../Factory';


export interface IConfigService {
  getAppVersion(): string;
  setAppVersion(val: string): IConfigService;
  getServerBaseUrl(): string;
  getServerBaseUrlForResource(): string;
  getFrontendUrl(): string;
  setFrontendUrl(val: string): IConfigService;
  getStripePubKey(): string;
  setStripePubKey(val: string): IConfigService;
  setServerBaseUrl(val: string): IConfigService;
  getClientId(): string;
  getClientSecret(): string;
  isMaintenanceMode(): boolean;
  setMaintenanceMode(val: boolean): IConfigService;
  getFullViewMode(): string;
  setFullViewMode(val: string): IConfigService;
  getEnvironment(): string;
  setEnvironment(val: string): IConfigService;
}

export class ConfigService implements IService, IConfigService {
  private static store = {
      appVersion: "",
      serverBaseUrl: "",
      frontendUrl: "",
      stripe_pub_key: "pk_test_9APWOBWOmxymaMUKLPm9NwlK",
      client_id: "iio-webapp",
      client_secret: "rL.PQhrK9vjjEoypwxHBY.YCEJThWMGGZj@jbqv8",
      maintenance: false,
      fullViewMode: "direct",
      environment: "dev"
    };

  public getAppVersion() {
    return ConfigService.store.appVersion;
  }

  public setAppVersion(version: string) {
    ConfigService.store.appVersion = version;

    return this;
  }

  public getServerBaseUrl() {
    return ConfigService.store.serverBaseUrl;
  }

  public setServerBaseUrl(url: string) {
    ConfigService.store.serverBaseUrl = url;

    return this;
  }

  public getServerBaseUrlForResource() {
    return ConfigService.store.serverBaseUrl.replace(":3501", "\\:3501").replace(":8080", "\\:8080");
  }

  public getFrontendUrl() {
    return ConfigService.store.frontendUrl;
  }

  public setFrontendUrl(url: string) {
    ConfigService.store.frontendUrl = url;

    return this;
  }

  public getStripePubKey() {
    return ConfigService.store.stripe_pub_key;
  }

  public setStripePubKey(key: string) {
    ConfigService.store.stripe_pub_key = key;

    return this;
  }

  public getClientId() {
    return ConfigService.store.client_id;
  }

  public getClientSecret() {
    return ConfigService.store.client_secret;
  }

  public isMaintenanceMode() {
    return ConfigService.store.maintenance;
  }

  public setMaintenanceMode(isMaintenance: boolean) {
    ConfigService.store.maintenance = isMaintenance;

    return this;
  }

  public getFullViewMode() {
    return ConfigService.store.fullViewMode;
  }

  public setFullViewMode(fullViewMode: string) {
    ConfigService.store.fullViewMode = fullViewMode;

      return this;
    }

    public getEnvironment() {
      return ConfigService.store.environment;
    }

    public setEnvironment(environment: string) {
      ConfigService.store.environment = environment;

      return this;
    }
  }

frontendApp.factory("ConfigService", [Factory.Create(ConfigService)]);
